import React, { Children } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Privacy() {
  return <div className="pt-20" data-id="element-1333">
      {/* Hero */}
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1334">
        <div className="container-custom" data-id="element-1335">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1336">
            <div className="w-16 h-16 bg-amber/10 rounded flex items-center justify-center mx-auto mb-6" data-id="element-1337">
              <ShieldCheckIcon className="h-8 w-8 text-amber" data-id="element-1338" />
            </div>
            <h1 className="mb-4" data-id="element-1339">Privacy Policy</h1>
            <p className="text-gray-600" data-id="element-1340">Last Updated: January 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-id="element-1341">
        <div className="container-custom" data-id="element-1342">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1343">
            <div className="bg-amber/5 border-l-4 border-amber p-6 rounded mb-12" data-id="element-1344">
              <p className="text-gray-700 leading-relaxed mb-0" data-id="element-1345">
                <strong data-id="element-1346">Our Commitment:</strong> We respect your privacy and are
                committed to protecting your personal information. This policy
                explains how we collect, use, and safeguard your data when you
                use our website and services.
              </p>
            </div>

            {/* Information We Collect */}
            <div className="mb-12" data-id="element-1347">
              <h2 className="text-navy mb-4" data-id="element-1348">1. Information We Collect</h2>

              <h3 className="text-xl text-navy mb-3" data-id="element-1349">
                Information You Provide
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1350">
                When you use our website or services, you may provide us with:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1351">
                <li data-id="element-1352">Contact information (name, email, phone number)</li>
                <li data-id="element-1353">
                  Company information (company name, role, team size, industry)
                </li>
                <li data-id="element-1354">
                  Information submitted through forms (strategy call requests,
                  newsletter signups)
                </li>
                <li data-id="element-1355">Communication preferences and feedback</li>
              </ul>

              <h3 className="text-xl text-navy mb-3" data-id="element-1356">
                Information Collected Automatically
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1357">
                When you visit our website, we automatically collect:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1358">
                <li data-id="element-1359">Device and browser information</li>
                <li data-id="element-1360">IP address and location data</li>
                <li data-id="element-1361">Pages visited and time spent on site</li>
                <li data-id="element-1362">Referring website and search terms</li>
              </ul>
            </div>

            {/* How We Use Information */}
            <div className="mb-12" data-id="element-1363">
              <h2 className="text-navy mb-4" data-id="element-1364">2. How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1365">
                We use the information we collect to:
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-1366">
                <li data-id="element-1367">Provide and improve our services</li>
                <li data-id="element-1368">Respond to your inquiries and schedule strategy calls</li>
                <li data-id="element-1369">
                  Send you relevant content, updates, and resources (with your
                  consent)
                </li>
                <li data-id="element-1370">Analyze website usage and optimize user experience</li>
                <li data-id="element-1371">Comply with legal obligations and protect our rights</li>
              </ul>
            </div>

            {/* Information Sharing */}
            <div className="mb-12" data-id="element-1372">
              <h2 className="text-navy mb-4" data-id="element-1373">
                3. Information Sharing and Disclosure
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1374">
                We do not sell your personal information. We may share your
                information with:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1375">
                <li data-id="element-1376">
                  <strong data-id="element-1377">Service Providers:</strong> Third-party vendors who
                  help us operate our website and services (e.g., email
                  providers, analytics tools, scheduling platforms)
                </li>
                <li data-id="element-1378">
                  <strong data-id="element-1379">Legal Requirements:</strong> When required by law or
                  to protect our rights and safety
                </li>
                <li data-id="element-1380">
                  <strong data-id="element-1381">Business Transfers:</strong> In connection with a
                  merger, acquisition, or sale of assets
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1382">
                All third-party service providers are contractually obligated to
                protect your information and use it only for the purposes we
                specify.
              </p>
            </div>

            {/* Data Security */}
            <div className="mb-12" data-id="element-1383">
              <h2 className="text-navy mb-4" data-id="element-1384">4. Data Security</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1385">
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction. These measures
                include:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1386">
                <li data-id="element-1387">Encryption of data in transit and at rest</li>
                <li data-id="element-1388">Regular security assessments and updates</li>
                <li data-id="element-1389">Access controls and authentication requirements</li>
                <li data-id="element-1390">Employee training on data protection</li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1391">
                However, no method of transmission over the internet is 100%
                secure. While we strive to protect your information, we cannot
                guarantee absolute security.
              </p>
            </div>

            {/* Your Rights */}
            <div className="mb-12" data-id="element-1392">
              <h2 className="text-navy mb-4" data-id="element-1393">5. Your Rights and Choices</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1394">
                You have the following rights regarding your personal
                information:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1395">
                <li data-id="element-1396">
                  <strong data-id="element-1397">Access:</strong> Request a copy of the personal
                  information we hold about you
                </li>
                <li data-id="element-1398">
                  <strong data-id="element-1399">Correction:</strong> Request correction of inaccurate
                  or incomplete information
                </li>
                <li data-id="element-1400">
                  <strong data-id="element-1401">Deletion:</strong> Request deletion of your personal
                  information (subject to legal obligations)
                </li>
                <li data-id="element-1402">
                  <strong data-id="element-1403">Opt-Out:</strong> Unsubscribe from marketing
                  communications at any time
                </li>
                <li data-id="element-1404">
                  <strong data-id="element-1405">Data Portability:</strong> Request a copy of your data
                  in a portable format
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1406">
                To exercise any of these rights, please contact us at
                contact@thehireadvantage.co
              </p>
            </div>

            {/* Cookies */}
            <div className="mb-12" data-id="element-1407">
              <h2 className="text-navy mb-4" data-id="element-1408">
                6. Cookies and Tracking Technologies
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1409">
                We use cookies and similar tracking technologies to enhance your
                experience on our website. Cookies are small files stored on
                your device that help us:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1410">
                <li data-id="element-1411">Remember your preferences and settings</li>
                <li data-id="element-1412">Understand how you use our website</li>
                <li data-id="element-1413">Improve website performance and functionality</li>
                <li data-id="element-1414">Deliver relevant content and advertising</li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1415">
                You can control cookies through your browser settings. Note that
                disabling cookies may affect website functionality.
              </p>
            </div>

            {/* Children's Privacy */}
            <div className="mb-12" data-id="element-1416">
              <h2 className="text-navy mb-4" data-id="element-1417">7. Children's Privacy</h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-1418">
                Our services are not directed to individuals under 18 years of
                age. We do not knowingly collect personal information from
                children. If you believe we have collected information from a
                child, please contact us immediately.
              </p>
            </div>

            {/* Changes to Policy */}
            <div className="mb-12" data-id="element-1419">
              <h2 className="text-navy mb-4" data-id="element-1420">
                8. Changes to This Privacy Policy
              </h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-1421">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or legal requirements. We will notify
                you of material changes by posting the updated policy on our
                website and updating the "Last Updated" date. Your continued use
                of our services after changes are posted constitutes acceptance
                of the updated policy.
              </p>
            </div>

            {/* Contact */}
            <div className="mb-12" data-id="element-1422">
              <h2 className="text-navy mb-4" data-id="element-1423">9. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1424">
                If you have questions, concerns, or requests regarding this
                Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-gray-50 rounded p-6 border border-gray-200" data-id="element-1425">
                <p className="text-gray-700 mb-2" data-id="element-1426">
                  <strong data-id="element-1427">The HIRE Advantage</strong>
                </p>
                <p className="text-gray-700" data-id="element-1428">
                  Email: contact@thehireadvantage.co
                </p>
              </div>
            </div>

            {/* Footer Note */}
            <div className="bg-navy/5 border-l-4 border-navy p-6 rounded" data-id="element-1429">
              <p className="text-gray-700 leading-relaxed mb-0" data-id="element-1430">
                <strong data-id="element-1431">Note:</strong> This Privacy Policy applies only to
                information collected through our website and services. It does
                not apply to information collected offline or through
                third-party websites linked from our site.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-gray-50" data-id="element-1432">
        <div className="container-custom" data-id="element-1433">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1434">
            <h2 className="mb-6" data-id="element-1435">Questions About Our Privacy Practices?</h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1436">
              We are committed to transparency and protecting your privacy. If
              you have any questions or concerns, we are here to help.
            </p>
            <a href="mailto:contact@thehireadvantage.co" className="inline-block bg-amber hover:bg-amber-dark text-white font-bold px-8 py-4 rounded transition-colors shadow-lg" data-id="element-1437">
              Contact Us →
            </a>
          </div>
        </div>
      </section>
    </div>;
}